import React, { useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'

export default function Eula () {
  return (
    <>
      <div
        className='bg-secondary p-2'
        style={{ overflowY: 'auto', height: '100vh' }}
      >
        <div>
          <Container
            fluid='md'
            className='p-4 my-3 bg-light'
            style={{ borderRadius: '25px', boxShadow: '0px 3px 5px #00000020' }}
          >
            <Row>
              <Col>
                <h3 className='text-center mb-5'>END USER LICENCE AGREEMENT</h3>
                <b>THIS AGREEMENT</b> made <b>BETWEEN</b>{' '}
                <b>Building Facade Manager Pty Ltd</b> (ACN 652578 580) of 6/195
                Elizabeth Street, Brisbane, Queensland, 4000<b> ("Licensor")</b>{' '}
                - and - <br /> “You” or "Licensee" (the "Parties")
                <br />
                <br />
                By continuing to log in and access the Building Façade Manager
                application, you agree to the conditions herein.
                <br />
                <br />
                <b className='spacing'>1. Definitions and interpretation</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>(a) Definitions</div>
                  <div className='ms-4 spacing'>
                    In this Agreement unless the context otherwise requires:
                  </div>
                  <div className='ms-4'>
                    <b>Agreement</b> means this agreement and includes any other
                    terms or conditions in the attached quotation.
                  </div>
                  <div className='ms-4'>
                    <b>Building Facade Manager</b> or <b>BFM</b> means any
                    software programs described by the Licensor as such - being
                    programs which relate to a secure multi-layered application
                    that manages the live workflow of building facades from
                    concept to completion including facade auditing and general
                    facade management, remediation repair tracking and new build
                    warranty/defect liability tracking.
                  </div>
                  <div className='ms-4'>
                    <b>Product</b> means Building Facade Manager.
                  </div>
                  <div className='ms-4'>
                    <b>Terms</b> means the terms and conditions of this
                    Agreement.
                  </div>
                  <div className='my-3'>(b) Interpretation</div>
                  <div className='ms-4 spacing'>
                    In this Agreement unless the context otherwise requires:
                  </div>
                  <div className='ms-4'>
                    (i) headings are for convenience only and do not affect its
                    interpretation and construction;
                  </div>
                  <div className='ms-4'>
                    (ii) the singular includes the plural and vice versa;
                  </div>
                  <div className='ms-4'>
                    (iii) words importing a gender include other genders;
                  </div>
                  <div className='ms-4'>
                    (iv) where any word or phrase is defined, any other part of
                    speech or other grammatical form of that word or phrase has
                    a cognate meaning;
                  </div>
                  <div className='ms-4'>
                    (v) a reference to any statute, proclamation, rule, code,
                    regulation, or ordinance includes any amendment,
                    consolidation, modification, re-enactment or reprint of it
                    or any statute, proclamation, rule, code, regulation, or
                    ordinance replacing it;
                  </div>
                  <div className='ms-4'>
                    (vi) "includes" is not a word of limitation;
                  </div>
                  <div className='ms-4'>
                    (vii) a reference to any thing is a reference to the whole
                    and each part of it, a reference to a group of persons is a
                    reference to all of them collectively and to each of them
                    individually; and
                  </div>
                  <div className='ms-4'>
                    (viii) a reference to a document includes all amendments or
                    supplements to, or replacements or novation of, that
                    document.
                  </div>
                </div>
                <br />
                <b>2. Acceptance of Licence Terms</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    (a) This Agreement is between You and the Licensor, and
                    governs the Products made available to You.
                  </div>
                  <div className='my-3'>(b) Upon:</div>
                  <div className='ms-4'>
                    (i) selecting the 'Accept' option when logging into the BFM
                    software;
                  </div>
                  <div className='ms-4'>
                    (ii) payment of the licence fee for the Product at the point
                    of purchasing the licence for the Product; or
                  </div>
                  <div className='ms-4'>
                    (iii) upon downloading, installing, or using the Product
                    (whichever comes first), You are granted a revocable,
                    non-transferable, non-exclusive, and limited licence ("the
                    Licence") strictly in accordance with the Terms of this
                    Agreement and any other terms or conditions set out in the
                    attached quotation.
                  </div>
                  (c) If You do not agree to the Terms of this Agreement, You
                  must not install, use, or copy the Product.
                </div>
                <br />
                <b>3.Additional Licence Terms</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    (a) The Licence granted under this Agreement entitles You to
                  </div>
                  <div className='ms-4'>
                    (i) install and use the Product on a single computer; or
                  </div>
                  <div className='ms-4'>
                    (ii) install and make an archival copy of the Product on a
                    storage medium other than a hard drive, and may only be used
                    for the reinstallation of the Product.
                  </div>
                  <div className='my-3'>
                    (b) The Licence does not permit the installation of the
                    Product
                  </div>
                  <div className='ms-4'>
                    (i) on more than one computer at any given time;
                  </div>
                  <div className='ms-4'>
                    (ii) on a system that allows shared use of applications;
                  </div>
                  <div className='ms-4'>(iii) on a multi-user network; or</div>
                  <div className='ms-4'>
                    (iv) on any configuration or system of computers that allow
                    multiple users, unless You have a licence for each separate
                    computer on which the product is installed and run.
                  </div>
                  <div className='my-3'>
                    (c) The Licence fee is the fee set out in the attached
                    quotation.
                  </div>
                  <div className='my-3'>
                    (d) The term of the Licence is the term set out in the
                    attached quotation.
                  </div>
                  <div className='my-3'>
                    (e) The Licence, the Licence fee and Licence term are
                    subject to any other terms and conditions set out in the
                    attached quotation.
                  </div>
                </div>
                <br />
                <b>4. Limitations</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>(a) Limitations on transfer</div>
                  <div className='ms-4'>
                    You may not assign your rights and obligations under this
                    Agreement, or redistribute, encumber, sell, rent, lease,
                    sublicence, or otherwise transfer your rights to the
                    Products.
                  </div>
                  <div className='my-3'>(b) Limitations on use</div>
                  <div className='ms-4'>You may not:</div>
                  <div className='ms-4'>
                    (i) share the Licence, or contents of the Product, with
                    others;
                  </div>
                  <div className='ms-4'>
                    (ii) copy, install or use the Product on any system with
                    more than one computer; oral
                  </div>
                  <div className='ms-4'>
                    (iii) permit the use, copying or installation of the Product
                    by more than one user or on more than one computer.
                  </div>
                  <div className='ms-4'>
                    unless You hold multiple, validly, licensed copies.
                  </div>
                  <div className='ms-4'>You may not:</div>
                  <div className='ms-4'>
                    (iv) decompile, "reverse engineer", disassemble, or
                    otherwise attempt to derive the source code for the Product;
                  </div>
                  <div className='ms-4'>
                    (v) broadcast, transmit or otherwise display in a public
                    forum or any venue not restricted to You, the Product, or
                    any part of the Product
                  </div>
                  <div className='ms-4'>
                    (vi) post the Product or part of the Product on any website;
                    or
                  </div>
                  <div className='ms-4'>
                    (vii) use the Product for commercial purposes.
                  </div>
                  <div className='my-3'>(c) Limitations on derived works</div>
                  <div className='ms-4'>
                    You may not modify the Product, create derivative works
                    based upon the Product, or use the Product to develop any
                    product having the same primary function as the Product.
                  </div>
                  <div className='my-3'>(d) Limitations on alteration</div>
                  <div className='my-3'>You may not:</div>
                  <div className='ms-3'>
                    (i) modify the Product or create any derivative work of the
                    Product or its accompanying documentation. Derivative works
                    include but are not limited to translations; or
                  </div>
                  <div className='ms-3'>
                    (ii) alter any files or libraries in any portion of the
                    Product.
                  </div>
                  <div className='my-3'>(e) Limitations on copying</div>
                  <div className='ms-3'>
                    You may not copy any part of the product except to the
                    extent that the licensed use inherently demands the creation
                    of a temporary copy stored in the computer memory and not
                    permanently affixed on storage medium.
                  </div>
                </div>
                <br />
                <b>5. Ownership</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    The Licensor, its subsidiaries, affiliates, and suppliers
                    retain all rights, title, and interest, including all
                    copyright and intellectual property rights, in and to, the
                    Product and all copies thereof.
                  </div>
                </div>
                <br />
                <b>6. Warranties and exclusions</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    (a) Provisions of the Competition and Consumer Act 2010 and
                    other laws in force from time to time in Australia may imply
                    guarantees, warranties, conditions, and impose obligations
                    on the Licensor and its subsidiaries, affiliates, and
                    suppliers ("Implied Terms"). If these Implied Terms apply,
                    the Licensor’s liability will be limited at its option to
                    resupply, repair or replacement of the Product or the cost
                    of such resupply, repair, or replacement, to the extent
                    permitted by law.
                  </div>
                  <div className='my-3'>
                    (b) Unless otherwise explicitly agreed to in writing by the
                    Licensor, subject to the Implied Terms, all representations,
                    guarantees, conditions and warranties of any nature are
                    expressly excluded.
                  </div>
                  <div className='my-3'>
                    (c) Nothing in this clause excludes, restricts, or modifies
                    your rights under an Implied Term.
                  </div>
                </div>
                <br />
                <b>7. Exclusion of damages</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    Subject to any Implied Term, the Licensor, its directors,
                    officers, employees, or agents will not be liable to You or
                    any other party for indirect, consequential, special,
                    incidental, punitive or exemplary damages of any kind
                    (including loss of revenues or profits or loss of business)
                    arising in connection with these Terms, the Product, any
                    software for the Product or any support services for the
                    Product, whether based on contract, tort, statute, or any
                    other legal theory.
                  </div>
                </div>
                <br />
                <b>8. Limitation of liability and remedies</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    To the extent that the applicable jurisdiction limits the
                    Licensor’s ability to disclaim any implied warranties, this
                    disclaimer shall be effective to the maximum extent
                    permitted.
                  </div>
                </div>
                <br />
                <b>9. Licensee indemnity</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    You will indemnify the Licensor, its directors, officers,
                    employees, agents, and contractors in full against any
                    liability, loss, damages, costs, and expenses as a result of
                    or in connection with your use of the Product, including but
                    not limited to, any modification by You of the Product which
                    causes the Product to infringe the intellectual property
                    rights of a third party.
                  </div>
                </div>
                <br />
                <b>10. Variation of Terms</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    The Licensor reserves the right to amend these Terms from
                    time to time without notice to You and You will be subject
                    to the Terms in force at the time You purchase the Licence
                    for the Product or download the Product whichever is
                    applicable.
                  </div>
                </div>
                <br />
                <b>11. Termination</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    Without prejudice to any other rights, the Licensor may
                    terminate this Agreement immediately and without further
                    notice if You fail to comply with the Terms of this
                    Agreement. In such event, You must either destroy or return
                    all copies of the Product as directed by the Licensor.
                  </div>
                </div>
                <br />
                <b>12. General provisions</b>
                <div className='ms-3 spacing-sm'>
                  <div className='my-3'>
                    (a) Any provision of, or the application of any provision of
                    this Agreement, which is prohibited in any jurisdiction is,
                    in that jurisdiction, ineffective only to the extent of that
                    prohibition.
                  </div>
                  <div className='my-3'>
                    (b) Any provision of, or the application of any provision of
                    this Agreement which is void, illegal or unenforceable in
                    any jurisdiction does not affect the validity, legality, or
                    enforceability of that provision in any other jurisdiction
                    or of the remaining provisions in that or any other
                    jurisdiction.
                  </div>
                  <div className='my-3'>
                    (c) The failure, delay, relaxation, or indulgence on the
                    part of a party in exercising, in part or whole, any power,
                    right or remedy conferred upon that party by these Terms
                    shall not operate as a waiver of that power, right, or
                    remedy.
                  </div>
                  <div className='my-3'>
                    (d) This Agreement contains the entire Agreement between the
                    Parties and supersedes any previous understandings,
                    commitments, or agreements, oral or written.
                  </div>
                  <div className='my-3'>
                    (e) If a clause is void, illegal or unenforceable, it may be
                    severed without affecting the enforceability of the other
                    provisions in this Agreement.
                  </div>
                  <div className='my-3'>
                    (f) This Agreement shall be governed by and construed in
                    accordance with the laws of Queensland.
                  </div>
                  <div className='my-3'>
                    (g) It is prohibited for users to share passwords with
                    anyone other than the user who owns the relevant email
                    address.
                  </div>
                  <div className='my-3'>
                    (h) Accessing the 3D models can only be done via the
                    Building Façade Manager application portal. Access via other
                    platforms or Application Programming Interfaces are
                    prohibited.
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  )
}
